import { DomainTypeShare } from '../types';

// Common/shared mock data used across multiple modules
export const mockDomainTypeShares: DomainTypeShare[] = [
  { type: 'Corporate', share: 48 },
  { type: 'Reference', share: 20 },
  { type: 'Editorial', share: 18 },
  { type: 'UGC', share: 9 },
  { type: 'Other', share: 3 },
  { type: 'Institutional', share: 1 },
  { type: 'Competitor', share: 1 },
];

export const mockDomainMovers = [
  { domain: 'bankrate.com', retrievals: 148 },
  { domain: 'nerdwallet.com', retrievals: 98 },
  { domain: 'stockbrokers.com', retrievals: 94 },
  { domain: 'reddit.com', retrievals: 82 },
  { domain: 'investopedia.com', retrievals: 73 },
  { domain: 'youtube.com', retrievals: 77 },
  { domain: 'kraken.com', retrievals: 80 },
  { domain: 'cnbc.com', retrievals: 87 },
];
